import React from 'react';
import HomePage from '../pages/HomePage';
import ClinicalMicrobiologyPage from '../pages/ClinicalMicrobiologyPage';
import AntimicrobialResistancePage from '../pages/AntimicrobialResistancePage';
import TreatmentRecommendationsPage from '../pages/TreatmentRecommendationsPage';
import ComplexityAssessmentPage from '../pages/ComplexityAssessmentPage';
import MonitoringPlansPage from '../pages/MonitoringPlansPage';
import InteractiveReportingPage from '../pages/InteractiveReportingPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import TermsAndConditionsPage from '../pages/TermsAndConditionsPage';
import FAQPage from '../pages/FAQPage';
import ApiDocumentationPage from '../pages/vendor/docs/ApiDocumentationPage';
import IntegrationGuidePage from '../pages/vendor/docs/IntegrationGuidePage';
import VendorSupportPage from '../pages/vendor/VendorSupportPage';
import ReportPage from '../pages/ReportPage';
import ReportGalleryPage from '../pages/ReportGalleryPage';
import ContactPage from '../pages/ContactPage';
import AboutUsPage from '../pages/AboutUsPage';
import BlogIndex from '../pages/blog';
import BlogPage from '../pages/blog/BlogPage';

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/features',
    element: <HomePage />,
  },
  {
    path: '/how-it-works',
    element: <HomePage />,
  },
  {
    path: '/about-us',
    element: <AboutUsPage />,
  },
  {
    path: '/clinical-microbiology',
    element: <ClinicalMicrobiologyPage />,
  },
  {
    path: '/antimicrobial-resistance',
    element: <AntimicrobialResistancePage />,
  },
  {
    path: '/treatment-recommendations',
    element: <TreatmentRecommendationsPage />,
  },
  {
    path: '/complexity-assessment',
    element: <ComplexityAssessmentPage />,
  },
  {
    path: '/monitoring-plans',
    element: <MonitoringPlansPage />,
  },
  {
    path: '/interactive-reporting',
    element: <InteractiveReportingPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsAndConditionsPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/blog',
    element: <BlogIndex />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPage />,
  },
  {
    path: '/vendor-documentation',
    element: <ApiDocumentationPage />,
  },
  {
    path: '/vendor-integration',
    element: <IntegrationGuidePage />,
  },
  {
    path: '/vendor-support',
    element: <VendorSupportPage />,
  },
  {
    path: '/vendor/docs/api-documentation',
    element: <ApiDocumentationPage />,
  },
  {
    path: '/report',
    element: <ReportPage />,
  },
  {
    path: '/reports',
    element: <ReportGalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
]; 